// extracted by mini-css-extract-plugin
export default {"planet":"planet_planet__+LcGz"};